import React from 'react';
import { Nen3140Score } from '../../../../common/src/domain/customInspectionTypes/nen3140/Nen3140Score';
import { nen3140ScoreToColorCode } from '../../../../common/src/domain/customInspectionTypes/nen3140/nen3140ScoreToColorCode';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Nen3140ScoreLabel = React.memo(function Nen3140ScoreLabel(props: { nen3140Score?: Nen3140Score | undefined | null }) {
    if (props.nen3140Score === null || props.nen3140Score === undefined) {
        return null;
    }
    const colorCode = nen3140ScoreToColorCode(props.nen3140Score);

    return (
        <span className="label p5 fs11" style={{ backgroundColor: colorCode }}>
            {props.nen3140Score}
        </span>
    );
});
